import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { CommonService } from 'src/app/_services/common.service';
import { MenuService } from 'src/app/_services/menu.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-nos-aines-racontent',
  templateUrl: './nos-aines-racontent.component.html',
  styleUrls: ['./nos-aines-racontent.component.scss']
})
export class NosAinesRacontentComponent implements OnInit {

  rubrique: any;
  menu: any;
  children: any;
  constructor(private commonService: CommonService, private titleService: Title, private ngDynamicBreadcrumbService: NgDynamicBreadcrumbService, 
    private route: ActivatedRoute, private menuService: MenuService) { }
  ngOnInit(): void {
    this.rubrique = "nos-aines-racontent";
    this.getChildren();
  }
  
  getChildren() {
    this.menuService.getChildren(this.rubrique).subscribe(data => {
      console.log(data);
      
      this.children = data[0]['items']; 
      this.commonService.changeData("");
      this.titleService.setTitle(data[0].nom);
      this.ngDynamicBreadcrumbService.updateBreadcrumbLabels({customMenu: "Ma commune", customSection: data[0].parent, customTitle: data[0].nom});   
    })
  }

}
